import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

// ----------------------------------------------------------------------

const initialState = {
  openCardCodeReceiver: false,
};

const Collapse3dCodeContext = createContext(initialState);

// ----------------------------------------------------------------------

Collapse3dCodeProvider.propTypes = {
  children: PropTypes.node,
};

function Collapse3dCodeProvider({ children }) {
  const [openCardCodeReceiver, setOpenCardCodeReceiver] = useState(false);

  const onOpenCardCodeReceiver = (production) => {
    setOpenCardCodeReceiver(production);
  };

  const onCloseCardCodeReceiver = () => {
    setOpenCardCodeReceiver(null);
  };

  return (
    <Collapse3dCodeContext.Provider
      value={{
        openCardCodeReceiver,
        onOpenCardCodeReceiver,
        onCloseCardCodeReceiver,
      }}
    >
      {children}
    </Collapse3dCodeContext.Provider>
  );
}

export { Collapse3dCodeProvider, Collapse3dCodeContext };
